import { Timezone } from 'skiliko-sdk'

const MILLISEC_IN_HOURS = 1000 * 60 * 60

const perExpert = experts => experts.map(expert => ({
  expert,
  availabilies: Timezone.scheduleToCurrentDates(expert.schedule, expert.timezone, expert.timezone_offset)
}))

const hoursPerWeekDay = experts => {
  return perExpert(experts)
    .map(e => ({
      ...e,
      hours: [...Array(7)]
        .map((_, i) => e.availabilies[i]
          .reduce((acc, value) => {
            acc += +value.to - +value.from
            return acc
          }, 0) / MILLISEC_IN_HOURS
        )
    }))
}

const totalHoursPerDay = experts => hoursPerWeekDay(experts)
  .map(e => e.hours)
  .reduce(
    (acc, value) => value.map((e, i) => acc[i] + e),
    [0, 0, 0, 0, 0, 0, 0]
  )

const maxHourPerDay = experts => hoursPerWeekDay(experts)
  .map(e => e.hours.sort((a, b) => b - a)[0])
  .sort((a, b) => b - a)[0]

export default {
  hoursPerWeekDay,
  maxHourPerDay,
  totalHoursPerDay
}



// WEBPACK FOOTER //
// ./src/api/availabilities.js